import { useEffect } from "react";

import { useRouter } from "next/router";

import { csrfParam, csrfToken } from "components/ui/source/shared/api/base_api";

export const handle4FALoginRedirect = (redirectUrl = "/profile") => {
  // Create a form element
  const form = document.createElement("form");
  form.method = "POST";
  form.action = `/accounts/auth/cognito_marriott?identity_provider=four-factor-authentication&redirect_path=${encodeURIComponent(
    redirectUrl,
  )}`;

  // Add the CSRF token
  const csrfTokenInput = document.createElement("input");
  csrfTokenInput.type = "hidden";
  csrfTokenInput.name = csrfParam(); // Function to get the CSRF parameter name
  csrfTokenInput.value = csrfToken(); // Function to get the CSRF token value

  form.appendChild(csrfTokenInput);

  // Append the form to the body
  document.body.appendChild(form);

  // Submit the form
  form.submit();
};

const useHandleLogoutAnd4FA = () => {
  const { query, pathname, replace } = useRouter();

  useEffect(() => {
    const params = new URLSearchParams(query as Record<string, string>);

    const updateUrl = () => {
      replace({ pathname, query: params.toString() }, undefined, {
        shallow: true,
      });
    };

    if (params.has("sign_out")) {
      params.delete("sign_out");
      updateUrl();
    }
    if (params.get("submit") === "4fa") {
      params.delete("submit");
      updateUrl();
      handle4FALoginRedirect();
    }
  }, [query, pathname, replace]);
};

export default useHandleLogoutAnd4FA;
